import { Directive, ElementRef, HostListener, Input, OnInit } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
    selector:'[customTextTrim]'
})

export class CustomTextTrimDirective {
    
    @Input('customTextTrim') formControlName!: string; 

    constructor(private el: ElementRef, private control: NgControl) {}
  
    @HostListener('change') onChange() {
      let value = this.el.nativeElement.value;
      if (value) {
        value = value.replace(/\s{2,}/g, ' ').trim();
        this.control.control?.setValue(value);
      }
    }
  }